import React from 'react';
import { AlertTriangle } from 'lucide-react';
import Button from '../common/Button';
import EmptyState from '../common/EmptyState';

// Fallback global pra erros de render. Evita tela branca.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error('Erro não tratado:', error, info);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-app-bg">
          <div className="max-w-md w-full">
            <EmptyState
              icon={AlertTriangle}
              title="Algo deu errado"
              description="Um erro inesperado ocorreu. Recarregue a página pra tentar de novo."
              action={<Button onClick={this.handleReload}>Recarregar</Button>}
            />
            {process.env.NODE_ENV !== 'production' && (
              <pre className="mt-6 p-4 bg-error/5 text-error text-xs rounded-lg overflow-auto">
                {this.state.error?.message}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
